/**
 * Shared utilities for {@link SpecialtyRow}, {@link SpecialtyCard} and {@link SpecialtiesDataTable}.
 */
import type { Specialty } from '@/types/specialty.types';
import type { SpecialtyFilters } from './specialty-configs';

/**
 * Resolves the status key used to look up {@link SPECIALTY_STATUS_CONFIG}
 * from the specialty's isActive boolean.
 */
export function getSpecialtyStatusKey(isActive: boolean): 'active' | 'inactive' {
  return isActive ? 'active' : 'inactive';
}

/** Client-side status + search filter (specialties are not paginated). */
export function filterSpecialties(
  specialties: Specialty[],
  filters: SpecialtyFilters,
): Specialty[] {
  let data = specialties;
  if (filters.statuses.length > 0) {
    data = data.filter((s) => {
      const key = s.isActive ? 'active' : 'inactive';
      return filters.statuses.includes(key);
    });
  }
  if (filters.searchTerm?.trim()) {
    const term = filters.searchTerm.toLowerCase();
    data = data.filter(
      (s) => s.label.toLowerCase().includes(term) || s.code.toLowerCase().includes(term),
    );
  }
  return data;
}

/** True when any status chip or search term is set. */
export function hasSpecialtyActiveFilters(filters: SpecialtyFilters): boolean {
  return filters.statuses.length > 0 || (!!filters.searchTerm && filters.searchTerm.length > 0);
}
